import { Base } from 'src/api/Base'

export class ExpenseAPI extends Base {
  static get entity() {
    return 'expense'
  }

  static async get({ id }) {
    const params = {
      ...this.datepicker,
      id,
    }

    const { data } = await this.request().get(`/${this.entity}/get`, {
      params,
    })

    return data
  }

  static async create({
    campaign,
    productId,
    targetBudget,
    productCategoryId,
    dealerShipId,
    flightDate,
    actualBudget,
    strategy,
    description,
    notes,
    coop,
    files,
  }) {
    const { month, year } = this.datepicker

    const params = {
      month,
      year,
      dealerShipId,
    }

    const body = {
      campaign,
      productId,
      targetBudget,
      productCategoryId,
      flightDate,
      actualBudget,
      strategy,
      description,
      notes,
      coop,
      files,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).post(`/${this.entity}/create`, body, {
      params,
    })

    return data
  }

  static async update({
    id,
    campaign,
    flightDate,
    targetBudget,
    actualBudget,
    strategy,
    description,
    notes,
    coop,
    files,
  }) {
    const params = {
      id,
    }

    const body = {
      campaign,
      flightDate,
      targetBudget,
      actualBudget,
      strategy,
      description,
      notes,
      coop,
      files,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).post(`/${this.entity}/update`, body, {
      params,
    })

    return data
  }

  static async updateActualBudget({ id, actualBudget }) {
    const params = {
      id,
    }

    const body = {
      actualBudget,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).post(`/${this.entity}/update-actual-budget`, body, {
      params,
    })

    return data
  }

  static async updateTargetBudget({ id, targetBudget }) {
    const params = {
      id,
    }

    const body = {
      targetBudget,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).post(`/${this.entity}/update-target-budget`, body, {
      params,
    })

    return data
  }

  static async find({ productCategoryId, productId, dealerShipId = this.datepicker.dealerShipId }) {
    const params = {
      ...this.datepicker,
      dealerShipId,
      productCategoryId,
      productId,
    }

    const { data } = await this.request().get(`/${this.entity}/find`, {
      params,
    })

    return data
  }

  static async getInvoices({ id }) {
    const params = {
      ...this.datepicker,
      id,
    }

    const { data } = await this.request().get(`/${this.entity}/invoices`, {
      params,
    })

    return data
  }

  static async addInvoice({ fileId, id }) {
    const params = {
      ...this.datepicker,
      id,
    }

    const body = {
      fileId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/add-invoice`, body, {
      params,
    })

    return data
  }

  static async deleteInvoice({ fileId, id }) {
    const params = {
      ...this.datepicker,
      id,
    }

    const body = {
      fileId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete-invoice`, body, {
      params,
    })

    return data
  }

  static async updateProduct({
    productId,
    price,
    totalTargetBudget,
    totalActualBudget,
    expensesPercents,
    dealerShipId = this.datepicker.dealerShipId,
  }) {
    const params = {
      ...this.datepicker,
      dealerShipId,
      productId,
    }

    const body = {
      price,
      expensesPercents,
      totalTargetBudget,
      totalActualBudget,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/update-product`, body, {
      params,
    })

    return data
  }

  static async deleteCategory({ productCategoryId }) {
    const { dealerShipId, dealerGroupId, month, year } = this.datepicker

    const body = {
      productCategoryId,
      dealerShipId,
      month,
      year,
      dealerGroupId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete-category`, body)

    return data
  }

  static async deleteProduct({ productId }) {
    const { dealerShipId, month, year } = this.datepicker

    const body = {
      productId,
      dealerShipId,
      month,
      year,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete-product`, body)

    return data
  }

  static async delete({ id }) {
    const params = {
      ...this.datepicker,
    }

    const body = {
      id,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete`, body, {
      params,
    })

    return data
  }
}
